import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import './SpecificDaysModal.css';
import { FaTimes, FaCalendarAlt } from 'react-icons/fa';

function SpecificDaysModal({ requestId, employeeName, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [days, setDays] = useState([]);
  const [requestDetails, setRequestDetails] = useState(null);

  useEffect(() => {
    const fetchDays = async () => {
      try {
        setLoading(true);
        
        // Fetch the request details first
        const { data: requestData, error: requestError } = await supabase
          .from('vacation_requests')
          .select('*')
          .eq('id', requestId)
          .single();
          
        if (requestError) throw requestError;
        setRequestDetails(requestData);
        
        // Fetch the specific days
        const { data, error } = await supabase
          .from('vacation_requests_days')
          .select('vacation_date')
          .eq('request_id', requestId)
          .order('vacation_date', { ascending: true });
          
        if (error) throw error;
        setDays(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching vacation days:', err);
        setError('Error al cargar los días de vacaciones');
      } finally {
        setLoading(false);
      }
    };
    
    fetchDays();
  }, [requestId]);

  // Format date as "Viernes 18 de Abril del 2025"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    // Add one day to compensate for timezone
    date.setDate(date.getDate() + 1);
    
    const weekdays = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    const weekday = weekdays[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    
    return `${weekday} ${day} de ${month} del ${year}`;
  };

  return (
    <div className="specific-days-modal-overlay">
      <div className="specific-days-modal-content">
        <div className="specific-days-modal-header">
          <h2>
            <FaCalendarAlt className="calendar-icon" /> 
            Días Solicitados
          </h2>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="specific-days-modal-body">
          <div className="employee-info">
            <h3>{employeeName}</h3>
            {requestDetails && (
              <p className="request-type">
                Tipo: {requestDetails.is_half_day ? 'Medio día' : 'Día completo'}
              </p>
            )}
          </div>
          
          {loading ? (
            <div className="loading-spinner">Cargando días...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : days.length === 0 ? (
            <div className="no-days">No se encontraron días para esta solicitud</div>
          ) : (
            <ul className="days-list">
              {days.map((day, index) => (
                <li key={index} className="day-item">
                  <div className="day-indicator"></div>
                  <span>{formatDate(day.vacation_date)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        
        <div className="specific-days-modal-footer">
          <button className="close-btn" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

export default SpecificDaysModal;